/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import ReduxUtils from '../../utils/ReduxUtils';
import RESOURCE_NAMES from '../../api/resources';
import { LIBRARY_ROOT } from '../../utils/Constants';
/**
 * Profile action types.
 */

var actionTypes = ReduxUtils.generateActionTypes(LIBRARY_ROOT, RESOURCE_NAMES.profile);
export default actionTypes;